import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Loader } from '@lms/ui';
import { HubBackLink } from '@/components/hub/HubBackLink';
import { api } from '@/lib/api';

interface H5pLibraryDetail {
  id: string;
  name: string;
  machineName: string;
  major: number;
  minor: number;
  patch: number;
  version?: string;
}

export function H5pLibraryShowPage() {
  const { libraryId } = useParams<{ libraryId: string }>();
  const { data, isLoading, error } = useQuery({
    queryKey: ['h5p', 'libraries', libraryId],
    queryFn: () => api<H5pLibraryDetail>(`/h5p/libraries/${libraryId}`),
    enabled: Boolean(libraryId),
  });

  return (
    <div className="lms-h5p-libraries lms-site-admin-hub-page font-sans">
      <header className="lms-h5p-libraries__header">
        <div className="lms-h5p-libraries__heading">
          <HubBackLink to="/h5p/libraries" />
          <div>
            <h1 className="text-3xl font-semibold text-dash-primary md:text-4xl">
              {data?.name ?? 'Librería H5P'}
            </h1>
            <p className="lms-h5p-libraries__subtitle">{data?.machineName}</p>
          </div>
        </div>
      </header>

      {error && (
        <p className="mb-4 text-sm text-red-600" role="alert">
          {(error as Error).message}
        </p>
      )}

      {isLoading ? (
        <div className="flex justify-center py-12">
          <Loader />
        </div>
      ) : (
        <div className="lms-h5p-libraries__table-card p-6 text-sm text-dash-on-surface-variant">
          <p>
            Versión: {data?.major ?? 0}.{data?.minor ?? 0}.{data?.patch ?? 0}
            {data?.version ? ` (${data.version})` : ''}
          </p>
          <Link to="/h5p/libraries" className="mt-4 inline-block text-dash-primary underline">
            Volver al listado
          </Link>
        </div>
      )}
    </div>
  );
}
